<script setup lang="ts">
import BadgeItem from '@/uiKit/BadgeItem.vue'
import IconSprite from '@/uiKit/IconSprite.vue'
import ObjectURLImage from '../Projects/ObjectURLImage.vue'
import { AGENT_NAME_FALLBACK } from './constants'
/**
 * Renders a badge that represents a project, showing the project's name and
 * cover image.
 */

defineProps<{
  readonly?: boolean
  coverImageUrl: string | null
  name: string | null
  size: 'sm' | 'md'
}>()
</script>

<template>
  <BadgeItem
    variant="neutral"
    :size="size"
    :label="name || AGENT_NAME_FALLBACK"
    :readonly="readonly"
  >
    <template #leading-icon>
      <div class="flex size-4 items-center justify-center">
        <ObjectURLImage
          v-if="coverImageUrl"
          class="rounded-corner-4 object-cover"
          :class="readonly && 'opacity-30'"
          :url="coverImageUrl"
          :loading="false"
        />
        <IconSprite
          v-else
          icon="table"
          size="sm"
          class="text-icon-subtlest"
        />
      </div>
    </template>
  </BadgeItem>
</template>
